import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  checkboxCustom: {
    '& .MuiIconButton-label > svg': {
      margin: '0 !important'
    }
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
  },
  boxContainer: {
    height: 100,
    backgroundColor: 'white',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    justifyContent: 'center',
    padding: 20,
    alignItems: 'center',
    width: '100%'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  boxItem: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    width: '100%'
  },
  headerInfo: {
    borderBottom: '1px solid #ddd',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  boxCenter: {
    display: 'flex',
    alignItems: 'center',
    width: 280
  },
  garing: {
    fontSize: 14,
    fontWeight: 600,
    color: '#ccc',
    margin: '0 10px'
  },
  headerText: {
    fontWeight: 600,
    fontSize: 16
  },
  bodyContent: {
    padding: 16,
    display: 'flex',
    justifyContent: 'space-between'
  },
  imageProduct: {
    width: 80,
    height: 80,
    objectFit: 'cover',
    borderRadius: 4,
    flexShrink: 0,
    padding: 6,
    border: '1px solid rgba(0, 0, 0, 0.23)'
  },
  footerContent: {
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderTop: '1px solid #ddd'
  },
  footerButton: {
    background: 'transparent',
    color: 'black',
    fontWeight: 500,
    fontSize: 14,
    padding: 0,
    border: 'none',
    cursor: 'pointer'
  },
  restItem: {
    transition: 'all ease'
  },
  orderTable: {
    width: '100%',
    fontSize: '14px',
    '& tr:nth-child(1)': {
      color: '#000'
    },
    '& td': {
      fontWeight: '500'
    },
    '& tr td:nth-child(3)': {
      paddingLeft: '1rem'
    },
    '& tr': {
      height: '25px'
    }
  }
})

export { useStyles }
